export default "__VITE_ASSET__d797f416__"